import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Thumbnail from './thumbnail-model'
import {
  CreateThumbnailAsync,
  DeleteThumbnailAsync,
  LoadThumbnailsAsync,
} from './thumbnail-thunk'
const initialState: thumbnailSliceState = {
  thumbnail: [],
  selected_thumbnail: '',
  is_loading_thumbnail: false,
  is_creating_thumbnail: false,
  is_deleting_thumbnail: false,
}
export interface thumbnailSliceState {
  thumbnail: Thumbnail[]
  selected_thumbnail?: string
  is_loading_thumbnail: boolean
  is_creating_thumbnail: boolean
  is_deleting_thumbnail: boolean
}
export const thumbnailSlice = createSlice({
  name: 'thumbnail',
  initialState,
  reducers: {
    setSelectedthumbnail: (state, action) => {
      state.selected_thumbnail = action.payload
    },
    clearStatethumbnail: (state) => {
      state.thumbnail = []
      state.is_loading_thumbnail = false
      state.is_creating_thumbnail = false
      state.is_deleting_thumbnail = false
    },
    mergethumbnail: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_thumbnail = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.thumbnail = merge(state.thumbnail, payload) as any
        }
      }
    },

    add_thumbnail: (state, action) => {
      if (action.payload) {
        state.thumbnail = [...state.thumbnail, action.payload]
      }
    },
    set_thumbnail: (state, action) => {
      let { key, value, id } = action.payload
      state.thumbnail = state.thumbnail.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadThumbnailsAsync.pending, (state) => {
      state.is_loading_thumbnail = true
    })
    builder.addCase(LoadThumbnailsAsync.fulfilled, (state, action) => {
      state.is_loading_thumbnail = false
      if (action.payload) {
        state.thumbnail = action.payload
      }
    })
    builder.addCase(LoadThumbnailsAsync.rejected, (state) => {
      state.is_loading_thumbnail = false
    })
    builder.addCase(CreateThumbnailAsync.pending, (state) => {
      state.is_creating_thumbnail = true
    })
    builder.addCase(CreateThumbnailAsync.fulfilled, (state) => {
      state.is_creating_thumbnail = false
    })
    builder.addCase(CreateThumbnailAsync.rejected, (state) => {
      state.is_creating_thumbnail = false
    })
    builder.addCase(DeleteThumbnailAsync.pending, (state) => {
      state.is_deleting_thumbnail = true
    })
    builder.addCase(DeleteThumbnailAsync.fulfilled, (state, action) => {
      state.is_deleting_thumbnail = false
      if (state.thumbnail) {
        state.thumbnail = state.thumbnail.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteThumbnailAsync.rejected, (state) => {
      state.is_deleting_thumbnail = false
    })
  },
})

export const {
  clearStatethumbnail,
  setSelectedthumbnail,
  set_thumbnail,
  mergethumbnail,
  add_thumbnail,
} = thumbnailSlice.actions

export const get_thumbnail =
  (id?: string) =>
  (state: {
    thumbnail: {
      thumbnail: Thumbnail[]
    }
  }): Thumbnail | null => {
    let temp = state?.thumbnail?.thumbnail?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.thumbnail?.thumbnail[0] || null
  }
export const get_selected_thumbnail = (state: {
  thumbnail: thumbnailSliceState
}): Thumbnail | null => {
  let id = state?.thumbnail?.selected_thumbnail
  let temp = state?.thumbnail?.thumbnail?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_thumbnail = (state: {
  thumbnail: {
    thumbnail: Thumbnail[]
  }
}): Thumbnail[] => {
  let temp = state?.thumbnail?.thumbnail
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_thumbnail_busy = (state: {
  thumbnail: thumbnailSliceState
}) => {
  return (
    state?.thumbnail.is_deleting_thumbnail ||
    state?.thumbnail.is_loading_thumbnail ||
    state?.thumbnail.is_creating_thumbnail
  )
}
export const is_deleting_thumbnail_busy = (state: {
  thumbnail: thumbnailSliceState
}) => {
  return state?.thumbnail.is_deleting_thumbnail
}
export const is_loading_thumbnail_busy = (state: {
  thumbnail: thumbnailSliceState
}) => {
  return state?.thumbnail.is_loading_thumbnail
}
export const is_creating_thumbnail_busy = (state: {
  thumbnail: thumbnailSliceState
}) => {
  return state?.thumbnail.is_creating_thumbnail
}

export default thumbnailSlice.reducer
